import { configureStore } from '@reduxjs/toolkit';
import { useSelector as useReduxSelector, TypedUseSelectorHook, useDispatch } from 'react-redux';

import { reducers } from './reducers';
import { authModel } from './Auth/middleware';
import { api } from './Api/middleware';
import { tenantsModel } from './Tenants/middleware';
import { usersModel } from './Users/middleware';
import { rolesModel } from './Roles/middleware';
import { queriesModel } from './Studio/Queries/middleware';
import { queryCreationModel } from './Studio/QueryCreation/middleware';
import { studioApiModel } from './Studio/Api/middleware';
import { datasetsModel } from './Studio/Datasets/middleware';
import { apiDetailsModel } from './ApiDetails/middleware';

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleWare) =>
    getDefaultMiddleWare({
      serializableCheck: false,
    }).concat([
      ...authModel,
      ...tenantsModel,
      ...usersModel,
      ...rolesModel,
      ...queriesModel,
      ...queryCreationModel,
      ...studioApiModel,
      ...datasetsModel,
      ...apiDetailsModel,
      api,
    ]),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: reducers,
    // @ts-ignore
    preloadedState,
  });
};
export type AppStore = ReturnType<typeof setupStore>;
